import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PlacementReportsModel } from 'common/models/page-models/reports/placement-reports/placement-report-data.model';
import { PlacementReportsListingModel } from 'common/models/page-models/reports/placement-reports/placement-reports-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { PlacementReportsWidgetService } from 'common/widget/reports/placement-reports.widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class PlacementReportsResolver extends GridResolver<PlacementReportsModel, PlacementReportsListingModel> {
    constructor(
        protected fs: PlacementReportsWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override modifyResponseData(dataModel: any, meta: any, widget: any) {
        dataModel['filterData'] = new PlacementReportsModel();
        return dataModel;
    }
}